// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.outer-timeline{
    display: flex;
    position: relative;
    height: -moz-fit-content;
    height: fit-content;
}

.outer-timeline h1{
    display: none;
}

.timeline{
    position: relative;
    display: flex;
    flex-direction: column;
    top:0%;
    width: 100%;
    height: 80vh;
    align-items: center;
    overflow-y:scroll;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.timeline::-webkit-scrollbar{display: none;}

.container{
    display: flex;
    padding: 10px 40px;
    position: relative;
    width: 90%;
    height: 100vh;
    max-height: -moz-fit-content;
    max-height: fit-content;
    animation: movedown 1s linear forwards;
    opacity: 0;
    margin-top: 15px;
    margin-bottom: 15px;
}

@keyframes movedown{
    0%{
        opacity: 1;
        transform: translateY(-30px);
    }
    100%{
        opacity: 1;
        transform: translateY(0px);
    }
}

.container:nth-child(1){
    animation-delay: 0s;
}

.container:nth-child(2){
    animation-delay: 1s;
}

.container:nth-child(3){
    animation-delay: 2s;
}

.container:nth-child(4){
    animation-delay: 3s;
}

.container:nth-child(5){
    animation-delay: 4s;
}

.container:nth-child(6){
    animation-delay: 5s;
}

.container:nth-child(7){
    animation-delay: 6s;
}

.text-box-left{
    padding: 20px 30px;
    width: 35%;
    box-shadow: 0px 0px 5px var(--text-color);
    background: rgb(255, 255, 255, 0.1);
    -webkit-backdrop-filter: blur(3px);
            backdrop-filter: blur(3px);
    position: relative;
    border-radius: 6px;
    font-size: 0.8rem;  
    left: -310px;
}

.text-box-right{
    padding: 20px 30px;
    width: 35%;
    box-shadow: 0px 0px 5px var(--text-color);
    background: rgb(255, 255, 255, 0.1);
    -webkit-backdrop-filter: blur(3px);
            backdrop-filter: blur(3px);
    position: relative;
    border-radius: 6px;
    font-size: 0.8rem;
    position: relative;
    right:-310px 
}

.left-container{
    display: flex;
    justify-content: center;
}

.right-container{
    display: flex;
    justify-content: center;
}

.container img{
    display: flex;
   position: absolute;
    width: 40px;
    border-radius: 50%;
    z-index: 10;
    top: 50px;
    left: 50%;
    transform: translate(-50%, -50%);
    justify-self: center;
    align-self: center;
}

@keyframes moveline{
    0%{
        height:0px
    }
    100%{
        height: 1200px;
    }
}

.text-box h2{
    font-weight: 600;
}

.text-box small{
    display: inline-block;
    margin-bottom: 15px;
}

.left-arrow{
    height: 0;
    width: 0;
    position: absolute;
    top: 28px;
    z-index: 1;
    border-top: 15px solid transparent;
    border-bottom: 15px solid transparent;
    border-left: 15px solid #fff;
    right: -15px;
}

.right-arrow{
    height: 0;
    width: 0;
    position: absolute;
    top: 28px;
    z-index: 1;
    border-top: 15px solid transparent;
    border-bottom: 15px solid transparent;
    border-right: 15px solid #fff;
    left: -15px;
}

.timeline::after{
    content: '';
    position: absolute;
    width: 6px;
    height: 1200px;
    background: #fff;
    /* top: 100px; */
    left: 50%;
    margin-left: -3px;
    z-index: -1;
    animation: moveline 5s linear forwards;
}

@media(max-width:998px){

    .outer-timeline{
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        height: -moz-fit-content;
        height: fit-content;
        overflow: hidden;
    }

    .outer-timeline h1{
        display: flex;
        width: -moz-fit-content;
        width: fit-content;
        position: relative;
        font-size: 1.9rem;
        margin-top:25%;
        margin-bottom: 1.5rem;
        }

    .timeline{
        height: -moz-fit-content;
        height: fit-content;
        /* background-color: aliceblue; */
        /* height: 90vh; */
    }

    .timeline::after{
        content: '';
        position: absolute;
        width: 6px;
        height: 1650px;
        background: #fff;
        /* top: 100px; */
        left: 30px;
        margin-left: -3px;
        z-index: -1;
        animation: moveline 5s linear forwards;
    }

    @keyframes moveline{
        0%{
            height:0px
        }
        100%{
            height: 100%;
        }
    }

    .container {
        display: flex;
        width: 100%;
        height: -moz-fit-content;
        height: fit-content;
        /* background-color: aliceblue; */
        
    }

    .left-container{
       
        display: flex;
        
        width: 100%;
        
    }

    .right-container{
        display: flex;
        
        width: 100%;
        
    }
    
    .text-box-left{
        left:30px;
        width: 60%;
    }
    .text-box-right{
        left: 30px;
        width: 60%;
    }
    .text-box small{
        margin-bottom: 10px;
    }

   .left-container img{
    left:70px;
   }
   .right-container img{
    left:70px;
    
   }
 
    .left-arrow, .right-arrow{
        border-right: 15px solid #fff;
        border-left: 0;
        left: -15px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/About/Timeline/Timeline.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kBAAkB;IAClB,wBAAmB;IAAnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,MAAM;IACN,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA,6BAA6B,aAAa,CAAC;;AAE3C;IACI,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,4BAAuB;IAAvB,uBAAuB;IACvB,sCAAsC;IACtC,UAAU;IACV,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,0BAA0B;IAC9B;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,yCAAyC;IACzC,mCAAmC;IACnC,kCAA0B;YAA1B,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,yCAAyC;IACzC,mCAAmC;IACnC,kCAA0B;YAA1B,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;GACd,kBAAkB;IACjB,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,SAAS;IACT,gCAAgC;IAChC,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI;QACI;IACJ;IACA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,QAAQ;IACR,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,kCAAkC;IAClC,qCAAqC;IACrC,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,QAAQ;IACR,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,kCAAkC;IAClC,qCAAqC;IACrC,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,iBAAiB;IACjB,WAAW;IACX,sCAAsC;AAC1C;;AAEA;;IAEI;QACI,kBAAkB;QAClB,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,wBAAmB;QAAnB,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,uBAAkB;QAAlB,kBAAkB;QAClB,kBAAkB;QAClB,iBAAiB;QACjB,cAAc;QACd,qBAAqB;QACrB;;IAEJ;QACI,wBAAmB;QAAnB,mBAAmB;QACnB,iCAAiC;QACjC,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,UAAU;QACV,cAAc;QACd,gBAAgB;QAChB,gBAAgB;QAChB,UAAU;QACV,iBAAiB;QACjB,WAAW;QACX,sCAAsC;IAC1C;;IAEA;QACI;YACI;QACJ;QACA;YACI,YAAY;QAChB;IACJ;;IAEA;QACI,aAAa;QACb,WAAW;QACX,wBAAmB;QAAnB,mBAAmB;QACnB,iCAAiC;;IAErC;;IAEA;;QAEI,aAAa;;QAEb,WAAW;;IAEf;;IAEA;QACI,aAAa;;QAEb,WAAW;;IAEf;;IAEA;QACI,SAAS;QACT,UAAU;IACd;IACA;QACI,UAAU;QACV,UAAU;IACd;IACA;QACI,mBAAmB;IACvB;;GAED;IACC,SAAS;GACV;GACA;IACC,SAAS;;GAEV;;IAEC;QACI,6BAA6B;QAC7B,cAAc;QACd,WAAW;IACf;AACJ","sourcesContent":[".outer-timeline{\n    display: flex;\n    position: relative;\n    height: fit-content;\n}\n\n.outer-timeline h1{\n    display: none;\n}\n\n.timeline{\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    top:0%;\n    width: 100%;\n    height: 80vh;\n    align-items: center;\n    overflow-y:scroll;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n}\n\n.timeline::-webkit-scrollbar{display: none;}\n\n.container{\n    display: flex;\n    padding: 10px 40px;\n    position: relative;\n    width: 90%;\n    height: 100vh;\n    max-height: fit-content;\n    animation: movedown 1s linear forwards;\n    opacity: 0;\n    margin-top: 15px;\n    margin-bottom: 15px;\n}\n\n@keyframes movedown{\n    0%{\n        opacity: 1;\n        transform: translateY(-30px);\n    }\n    100%{\n        opacity: 1;\n        transform: translateY(0px);\n    }\n}\n\n.container:nth-child(1){\n    animation-delay: 0s;\n}\n\n.container:nth-child(2){\n    animation-delay: 1s;\n}\n\n.container:nth-child(3){\n    animation-delay: 2s;\n}\n\n.container:nth-child(4){\n    animation-delay: 3s;\n}\n\n.container:nth-child(5){\n    animation-delay: 4s;\n}\n\n.container:nth-child(6){\n    animation-delay: 5s;\n}\n\n.container:nth-child(7){\n    animation-delay: 6s;\n}\n\n.text-box-left{\n    padding: 20px 30px;\n    width: 35%;\n    box-shadow: 0px 0px 5px var(--text-color);\n    background: rgb(255, 255, 255, 0.1);\n    backdrop-filter: blur(3px);\n    position: relative;\n    border-radius: 6px;\n    font-size: 0.8rem;  \n    left: -310px;\n}\n\n.text-box-right{\n    padding: 20px 30px;\n    width: 35%;\n    box-shadow: 0px 0px 5px var(--text-color);\n    background: rgb(255, 255, 255, 0.1);\n    backdrop-filter: blur(3px);\n    position: relative;\n    border-radius: 6px;\n    font-size: 0.8rem;\n    position: relative;\n    right:-310px \n}\n\n.left-container{\n    display: flex;\n    justify-content: center;\n}\n\n.right-container{\n    display: flex;\n    justify-content: center;\n}\n\n.container img{\n    display: flex;\n   position: absolute;\n    width: 40px;\n    border-radius: 50%;\n    z-index: 10;\n    top: 50px;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    justify-self: center;\n    align-self: center;\n}\n\n@keyframes moveline{\n    0%{\n        height:0px\n    }\n    100%{\n        height: 1200px;\n    }\n}\n\n.text-box h2{\n    font-weight: 600;\n}\n\n.text-box small{\n    display: inline-block;\n    margin-bottom: 15px;\n}\n\n.left-arrow{\n    height: 0;\n    width: 0;\n    position: absolute;\n    top: 28px;\n    z-index: 1;\n    border-top: 15px solid transparent;\n    border-bottom: 15px solid transparent;\n    border-left: 15px solid #fff;\n    right: -15px;\n}\n\n.right-arrow{\n    height: 0;\n    width: 0;\n    position: absolute;\n    top: 28px;\n    z-index: 1;\n    border-top: 15px solid transparent;\n    border-bottom: 15px solid transparent;\n    border-right: 15px solid #fff;\n    left: -15px;\n}\n\n.timeline::after{\n    content: '';\n    position: absolute;\n    width: 6px;\n    height: 1200px;\n    background: #fff;\n    /* top: 100px; */\n    left: 50%;\n    margin-left: -3px;\n    z-index: -1;\n    animation: moveline 5s linear forwards;\n}\n\n@media(max-width:998px){\n\n    .outer-timeline{\n        position: relative;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        height: fit-content;\n        overflow: hidden;\n    }\n\n    .outer-timeline h1{\n        display: flex;\n        width: fit-content;\n        position: relative;\n        font-size: 1.9rem;\n        margin-top:25%;\n        margin-bottom: 1.5rem;\n        }\n\n    .timeline{\n        height: fit-content;\n        /* background-color: aliceblue; */\n        /* height: 90vh; */\n    }\n\n    .timeline::after{\n        content: '';\n        position: absolute;\n        width: 6px;\n        height: 1650px;\n        background: #fff;\n        /* top: 100px; */\n        left: 30px;\n        margin-left: -3px;\n        z-index: -1;\n        animation: moveline 5s linear forwards;\n    }\n\n    @keyframes moveline{\n        0%{\n            height:0px\n        }\n        100%{\n            height: 100%;\n        }\n    }\n\n    .container {\n        display: flex;\n        width: 100%;\n        height: fit-content;\n        /* background-color: aliceblue; */\n        \n    }\n\n    .left-container{\n       \n        display: flex;\n        \n        width: 100%;\n        \n    }\n\n    .right-container{\n        display: flex;\n        \n        width: 100%;\n        \n    }\n    \n    .text-box-left{\n        left:30px;\n        width: 60%;\n    }\n    .text-box-right{\n        left: 30px;\n        width: 60%;\n    }\n    .text-box small{\n        margin-bottom: 10px;\n    }\n\n   .left-container img{\n    left:70px;\n   }\n   .right-container img{\n    left:70px;\n    \n   }\n \n    .left-arrow, .right-arrow{\n        border-right: 15px solid #fff;\n        border-left: 0;\n        left: -15px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
